import { render, staticRenderFns } from "./CbsFunctionArgument.vue?vue&type=template&id=752a6226&scoped=true"
import script from "./CbsFunctionArgument.vue?vue&type=script&lang=js"
export * from "./CbsFunctionArgument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752a6226",
  null
  
)

export default component.exports